import { useAxios } from '@/context/axiosContext'
import { useEffect, useState } from 'react'
import { fieldNames, NoticeListItem } from '../noticeItem'
import { Badge, Button, Input, Select, Table } from '@/components'
import { useLocation, useNavigate } from 'react-router-dom'
import Pagination from '@/pages/board/_components/pagination'
import {
  getBadgeLabel,
  getMobileBadgeClass,
  withDrawnCumtomer,
} from '@/pages/board/boardItem'
import commonUtils from '@/utils/commonUtils'
import numberUtils from '@/utils/numberUtils'
import { NoticePopup } from './noticePopup'
import { useResponsive } from '@/hooks/useResponsive'
import '../noticeMobile.css'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

export interface GetNoticeData {
  srchOpt?: string //검색옵션
  srchStr?: string //검색어
  page?: number //페이지
}

export const NoticeList = () => {
  const axios = useAxios()
  const [noticeList, setNoticeList] = useState<NoticeListItem[]>([])

  const navigate = useNavigate()
  const location = useLocation()
  const [totalCount, setTotalCount] = useState(0) //페이지 count
  const [page, setPage] = useState(location.state?.page || 1)
  const [bbsTy, setBbsTY] = useState('01')
  const [bbsSj, setBbsSj] = useState('')
  const [srchData, setSrchData] = useState({
    srchOpt: location.state?.srchOpt || '01',
    srchStr: location.state?.srchStr || '',
  })
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const adminName = '운영자'
  // API 호출을 위한 useEffect 훅
  useEffect(() => {
    // API 호출 함수
    getNoticeList() // 컴포넌트 마운트 시 API 호출
  }, [page]) // 빈 배열을 넣으면 처음 한 번만 호출됨

  const handlePageChange = (page: number) => {
    setPage(page)
    setBbsTY(bbsTy)
  }

  const handleSearch = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement // 타입 캐스팅
    setSrchData((prev) => ({ ...prev, [name]: value }))
  }
  const readNotices = JSON.parse(localStorage.getItem('readNotices') || '[]')

  //글상세보기
  const handleDetailView = (noticeSn: number) => {
    navigate(`/notice/detail?noticeSn=${noticeSn}`, {
      state: {
        page: page,
        srchOpt: srchData.srchOpt,
        srchStr: srchData.srchStr,
      },
    })
  }

  const isNewNotice = (regDate: string): boolean => {
    const today = new Date()
    const noticeDate = new Date(
      `${regDate.substring(0, 4)}-${regDate.substring(4, 6)}-${regDate.substring(6, 8)}`,
    )
    const diffTime = today.getTime() - noticeDate.getTime()
    const diffDays = diffTime / (1000 * 3600 * 24)
    return diffDays <= 7 // 7일 이내이면 NEW 표시
  }

  const getNoticeList = async () => {
    try {
      const data: GetNoticeData = {
        page: page,
        srchOpt: srchData.srchOpt,
        srchStr: srchData.srchStr,
      }
      const response = await axios.get(`/notice/list`, {
        headers: { 'Cache-Control': 'no-cache' },
        params: { ...data },
      })
      const { noticeList, pageCnt } = response.data.data
      // 응답 데이터가 배열인지 확인하고 상태 업데이트
      if (Array.isArray(noticeList)) {
        setNoticeList(noticeList)
      }
      setTotalCount(pageCnt)
    } catch (err: any) {
      console.error('Error fetching noticeList:', err)
    }
  }

  const commonStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center' as const,
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      getNoticeList()
    }
  }

  return (
    <>
      {!isMobile ? (
        <div>
          <Table
            hover={true}
            bordered={true}
            style={{ width: '100%', tableLayout: 'auto', overflow: 'hidden' }}
          >
            <thead>
              {fieldNames.map((header, index) => (
                <th key={index} scope="col" style={commonStyle}>
                  {header}
                </th>
              ))}
            </thead>
            <tbody>
              {noticeList.length > 0 ? (
                (() => {
                  const noticePosts = noticeList.filter(
                    (item) => item.tpNoticeYn === 'Y',
                  ) // 공지글
                  const normalPosts = noticeList.filter(
                    (item) => item.tpNoticeYn !== 'Y',
                  ) // 일반 글

                  const noticeCount = noticePosts.length // 공지글 개수
                  const totalNormalPosts = totalCount - noticeCount // 전체 일반 글 개수 (DB에서 가져온 전체 데이터 수)

                  const startNumber = totalNormalPosts - (page - 1) * 10 // 현재 페이지에서 시작할 번호

                  const sortedNotices = [...noticePosts, ...normalPosts] // 공지글 + 일반 글

                  return sortedNotices.map((item, index) => {
                    const isRead = readNotices.includes(item.noticeSn)
                    const isNew = isNewNotice(item.regDate)

                    const displayNumber =
                      item.tpNoticeYn === 'Y'
                        ? '-'
                        : startNumber - (index - noticeCount)

                    return (
                      <tr key={item.noticeSn}>
                        <td style={{ textAlign: 'right', width: '30px' }}>
                          {displayNumber}
                        </td>
                        <td
                          style={{ textAlign: 'left', cursor: 'pointer' }}
                          onClick={() => handleDetailView(item.noticeSn)}
                        >
                          {item.tpNoticeYn === 'Y' && (
                            <Badge color="neverbe">
                              {getBadgeLabel(item.tpNoticeYn, 'Y')}
                            </Badge>
                          )}
                          &nbsp;&nbsp;
                          {item.noticeSj}
                          &nbsp;&nbsp;
                          {isNew && !isRead && <Badge color="warning">N</Badge>}
                        </td>
                        <td style={{ textAlign: 'center', width: '50px' }}>
                          {adminName}
                        </td>
                        <td style={{ textAlign: 'center', width: '50px' }}>
                          {commonUtils.formatDate(item.regDate, false)}
                        </td>
                        <td style={{ textAlign: 'right', width: '40px' }}>
                          {numberUtils.formatViewCount(item.readngCnt)}
                        </td>
                      </tr>
                    )
                  })
                })()
              ) : (
                <tr>
                  <td colSpan={5} style={{ textAlign: 'center' }}>
                    게시글이 없습니다. 다른검색어로 다시 시도해 주세요.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div style={{ display: 'flex' }}>
            <div style={{ marginLeft: 'auto' }}>
              <div style={{ display: 'flex', gap: '5px' }}>
                <Select
                  id="srchOpt"
                  name="srchOpt"
                  width="100px"
                  value={srchData.srchOpt}
                  onChange={handleSearch}
                >
                  <option value="01">제목</option>
                  <option value="02">내용</option>
                  <option value="03">제목+내용</option>
                </Select>
                <Input
                  id="srchStr"
                  name="srchStr"
                  placeholder="검색어를 입력하세요."
                  width="300px"
                  value={srchData.srchStr}
                  onChange={handleSearch}
                  onKeyDown={handleKeyDown}
                />
                <Button color="neverbe" onClick={getNoticeList}>
                  검색
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="mobile-view">
          <div className="mobile-board-container">
            {noticeList.length > 0 ? (
              (() => {
                // 웹용과 동일한 로직 적용
                const noticePosts = noticeList.filter(
                  (item) => item.tpNoticeYn === 'Y',
                ) // 공지글
                const normalPosts = noticeList.filter(
                  (item) => item.tpNoticeYn !== 'Y',
                ) // 일반 글

                const noticeCount = noticePosts.length // 공지글 개수
                const totalNormalPosts = totalCount - noticeCount // 전체 일반 글 개수 (DB에서 가져온 전체 데이터 수)

                const startNumber = totalNormalPosts - (page - 1) * 10 // 현재 페이지에서 시작할 번호

                const sortedNotices = [...noticePosts, ...normalPosts] // 공지글 + 일반 글

                return sortedNotices.map((item, index) => {
                  const isRead = readNotices.includes(item.noticeSn)
                  const isNew = isNewNotice(item.regDate)

                  const displayNumber =
                    item.tpNoticeYn === 'Y'
                      ? '-'
                      : startNumber - (index - noticeCount)

                  return (
                    <div
                      className="mobile-post-item"
                      key={item.noticeSn}
                      onClick={() => handleDetailView(item.noticeSn)}
                    >
                      <div className="mobile-post-header">
                        {/* <div className="mobile-post-number">
                          {displayNumber}
                        </div> */}
                        <div className="title-col">
                          {item.tpNoticeYn === 'Y' && (
                            <span
                              className={getMobileBadgeClass(item.tpNoticeYn)}
                            >
                              {getBadgeLabel(item.tpNoticeYn, 'Y')}
                            </span>
                          )}
                          {/* {isNew && !isRead && (
                            <span className="mobile-new-badge">N</span>
                          )} */}
                        </div>
                      </div>
                      <div className="mobile-post-title">{item.noticeSj}</div>
                      <div className="mobile-post-meta">
                        <div className="mobile-post-left-meta">
                          <span className="mobile-post-user">{adminName}</span>
                          <span className="mobile-post-date">
                            {commonUtils.formatDate(item.regDate, false)}
                          </span>
                        </div>
                        <div className="mobile-post-right-meta">
                          <div className="mobile-post-views">
                            <span>views</span>
                            <span>
                              {numberUtils.formatViewCount(item.readngCnt)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              })()
            ) : (
              <div id="noSearchResults" className="mobile-no-data">
                <div className="mobile-no-data-icon">📭</div>
                <div className="mobile-no-data-title">검색 결과가 없습니다</div>
                <div className="mobile-no-data-message">
                  검색하신 조건에 맞는 게시글이 없습니다.
                  <br />
                  새로운 게시글을 등록하거나 다른 검색어로
                  <br />
                  다시 시도해 주세요.
                </div>
              </div>
            )}
          </div>
          <div className="mobile-search-container">
            <input
              type="text"
              id="srchStr"
              name="srchStr"
              className="mobile-search-input"
              placeholder="검색어를 입력하세요"
              value={srchData.srchStr}
              onChange={handleSearch}
              onKeyDown={handleKeyDown}
            />
            <div className="mobile-search-row">
              <select
                id="srchOpt"
                name="srchOpt"
                className="mobile-search-select"
                value={srchData.srchOpt}
                onChange={handleSearch}
              >
                <option value="01">제목</option>
                <option value="02">내용</option>
                <option value="03">제목+내용</option>
              </select>
              <button className="mobile-search-btn" onClick={getNoticeList}>
                검색
              </button>
            </div>
          </div>
        </div>
      )}
      {totalCount > 0 && (
        <Pagination
          totalCount={totalCount}
          onPageChange={handlePageChange}
          paramPage={location.state?.page || 1}
        />
      )}
    </>
  )
}
